<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <p v-if="messageWarning" class="mt-0 text-center text-warning">
      <b>{{ messageWarning ? messageWarning : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_match">Match</label>
      </div>
      <select id="resultat_match"
              v-model="dataForm.match_id"
              class="custom-select"
              @change="setMatch()"
              name="resultat_match">
        <option :key="match.match_id"
                :value="match.match_id"
                v-for="match in matchs">
          {{ equipes ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_a_id )[0].nom.toUpperCase() : '' }}
          vs
          {{ equipes ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_b_id )[0].nom.toUpperCase() : '' }}
          ({{ new Date(match.date_rencontre).toLocaleDateString() }} - {{ match.temps_rencontre }})
          ({{ returnJourney(match.journee) }})
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_domiciliee">Equipe domiciliée</label>
      </div>
      <input id="equipe_domiciliee"
             class="form-control"
             :value="equipe_a ? equipe_a.nom.toUpperCase() : ''"
             disabled
             type="text">
    </div>
<!--
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_equipe_a">Equipe domiciliée</label>
      </div>
      <select id="resultat_equipe_a"
              v-model="dataForm.equipe_a_buteurs_id"
              class="custom-select"
              name="resultat_equipe_a">
        <option>Choisissez l'équipe domiciliée...</option>
      </select>
    </div>
-->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_score_equipe_a">Score équipe domiciliée</label>
      </div>
      <input id="resultat_score_equipe_a"
             v-model="dataForm.score_equipe_a"
             class="form-control"
             name="resultat_score_equipe_a"
             placeholder="Entrez le nombre de buts marqués par l'équipe domiciliée"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="equipe_visiteuse">Equipe visiteuse</label>
      </div>
      <input id="equipe_visiteuse"
             class="form-control"
             :value="equipe_b ? equipe_b.nom.toUpperCase() : ''"
             disabled
             type="text">
    </div>
<!--
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_equipe_b">Equipe visiteuse</label>
      </div>
      <select id="resultat_equipe_b"
              v-model="dataForm.equipe_b_buteurs_id"
              class="custom-select"
              name="resultat_equipe_b">
        <option>Choisissez une équipe visiteuse...</option>
      </select>
    </div>
-->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="resultat_score_equipe_b">Score équipe visiteuse</label>
      </div>
      <input id="resultat_score_equipe_b"
             v-model="dataForm.score_equipe_b"
             class="form-control"
             name="resultat_score_equipe_b"
             placeholder="Entrez le nombre de buts marqués par l'équipe domiciliée"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_date_rencontre">Date et Temps de rencontre</label>
        <label class="input-group-text" for="match_temps_rencontre"></label>
      </div>
      <input id="match_date_rencontre"
             :value="(match) ? match.date_rencontre : ''"
             disabled
             class="form-control"
             name="match_date_rencontre"
             type="date">
      <input id="match_temps_rencontre"
             :value="(match) ? match.temps_rencontre : ''"
             disabled
             class="form-control"
             name="match_temps_rencontre"
             type="time">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_terrain">Terrain</label>
      </div>
      <select id="match_terrain"
              class="custom-select"
              disabled
              name="match_terrain">
        <option>{{ (terrain) ? terrain.nom : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="match_arbitre_principal">Arbitre Principal</label>
      </div>
      <select id="match_arbitre_principal"
              class="custom-select"
              disabled
              name="match_arbitre_principal">
        <option>
          {{ (arbitre_principal) ?
            (
                arbitre_principal.prenom.charAt(0).toUpperCase() + arbitre_principal.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.postnom.charAt(0).toUpperCase() + arbitre_principal.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.nom.charAt(0).toUpperCase() + arbitre_principal.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_arbitre_assistant_1">Arbitre Assistant 1</label>
      </div>
      <select id="match_arbitre_assistant_1"
              disabled
              class="custom-select"
              name="match_arbitre_assistant_1">
        <option>
          {{ (arbitre_assistant_1) ?
            (
                arbitre_assistant_1.prenom.charAt(0).toUpperCase() + arbitre_assistant_1.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_1.postnom.charAt(0).toUpperCase() + arbitre_assistant_1.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_1.nom.charAt(0).toUpperCase() + arbitre_assistant_1.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_arbitre_assistant_2">Arbitre Assistant 2</label>
      </div>
      <select id="match_arbitre_assistant_2"
              disabled
              class="custom-select"
              name="match_arbitre_assistant_2">
        <option>
          {{ (arbitre_assistant_2) ?
            (
                arbitre_assistant_2.prenom.charAt(0).toUpperCase() + arbitre_assistant_2.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_2.postnom.charAt(0).toUpperCase() + arbitre_assistant_2.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_2.nom.charAt(0).toUpperCase() + arbitre_assistant_2.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_arbitre_commissaire">Arbitre Commissaire</label>
      </div>
      <select id="match_arbitre_commissaire"
              disabled
              class="custom-select"
              name="match_arbitre_commissaire">
        <option>
          {{ (arbitre_commissaire) ?
            (
                arbitre_commissaire.prenom.charAt(0).toUpperCase() + arbitre_commissaire.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_commissaire.postnom.charAt(0).toUpperCase() + arbitre_commissaire.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_commissaire.nom.charAt(0).toUpperCase() + arbitre_commissaire.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_saison">Saison</label>
      </div>
      <select id="match_saison"
              disabled
              class="custom-select"
              name="match_saison">
        <option>
          {{ (saison) ? (saison.annee_debut + ' - ' +
                         saison.annee_fin): '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_championnat">Championnat</label>
      </div>
      <select id="match_championnat"
              disabled
              class="custom-select"
              name="match_championnat">
        <option>
          {{ (championnat) ? championnat.nom : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_phase">Phase</label>
      </div>
      <select id="match_phase"
              disabled
              class="custom-select"
              name="match_phase">
        <option value="aller">{{ (match) ? match.phase : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_journee">Journée</label>
      </div>
      <input id="match_journee"
             class="form-control"
             disabled
             :value="(match) ? match.journee : ''"
             name="match_journee"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      //
      matchs: null,
      equipes: null,
      terrains: null,
      arbitres: null,
      saisons: null,
      championnats: null,
      //
      match: null,
      equipe_a: null,
      equipe_b: null,
      terrain: null,
      arbitre_principal: null,
      arbitre_assistant_1: null,
      arbitre_assistant_2: null,
      arbitre_commissaire: null,
      saison: null,
      championnat: null,
      messageSuccess: '',
      messageFailure: '',
      messageWarning: '',
      dataForm: {
        match_id: '',
        equipe_a_id: '',
        equipe_b_id: '',
        date_rencontre: '',
        temps_rencontre: '',
        terrain_id: '',
        arbitre_principal_id: '',
        arbitre_assistant_1_id: '',
        arbitre_assistant_2_id: '',
        arbitre_commissaire_id: '',
        score_equipe_a: '',
        score_equipe_b: '',
        saison_id: '',
        championnat_id: '',
        phase: '',
        journee: '',
        table: 'matchs_joues',
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    },
    messageWarning : function () {
      let vm = this;
      setTimeout( () => vm.messageWarning = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
      'axiosDeleteData',
    ]),
    setMatch() {
      this.match = this.matchs.filter( (match) => match.match_id === this.dataForm.match_id)[0]
      this.equipe_a = this.equipes.filter( (equipe) => equipe.equipe_id === this.match.equipe_a_id )[0]
      this.equipe_b = this.equipes.filter( (equipe) => equipe.equipe_id === this.match.equipe_b_id )[0]
      this.terrain = this.terrains.filter( (terrain) => terrain.terrain_id === this.match.terrain_id )[0]
      this.arbitre_principal = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === this.match.arbitre_principal_id )[0]
      this.arbitre_assistant_1 = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === this.match.arbitre_assistant_1_id )[0]
      this.arbitre_assistant_2 = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === this.match.arbitre_assistant_2_id )[0]
      this.arbitre_commissaire = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === this.match.arbitre_commissaire_id )[0]
      this.saison = this.saisons.filter( (saison) => saison.saison_id === this.match.saison_id )[0]
      this.championnat = this.championnats.filter( (championnat) => championnat.championnat_id === this.match.championnat_id )[0]
      this.setDataForm(this.match)
    },
    setDataForm(match){
      this.dataForm.match_id = match.match_id
      this.dataForm.equipe_a_id = match.equipe_a_id
      this.dataForm.equipe_b_id = match.equipe_b_id
      this.dataForm.date_rencontre = match.date_rencontre
      this.dataForm.temps_rencontre = match.temps_rencontre
      this.dataForm.terrain_id = match.terrain_id
      this.dataForm.arbitre_principal_id = match.arbitre_principal_id
      this.dataForm.arbitre_assistant_1_id = match.arbitre_assistant_1_id
      this.dataForm.arbitre_assistant_2_id = match.arbitre_assistant_2_id
      this.dataForm.arbitre_commissaire_id = match.arbitre_commissaire_id
      this.dataForm.saison_id = match.saison_id
      this.dataForm.championnat_id = match.championnat_id
      this.dataForm.phase = match.phase
      this.dataForm.journee = match.journee
    },
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201){
              this.axiosDeleteData({
                table: 'matchs_non_joues',
                table_id: this.match.match_non_joue_id,
              })
                  .then(() => {
                    this.messageSuccess = "Résultat ajouté avec succès !"
                  })
                  .catch(() => {
                    this.messageWarning = "Résultat ajouté avec succès ! Mais le match n'a pas pu être supprimé de la liste des match non joués !"
                  })
            } else{
              this.messageFailure = "Une erreur est survenue lors de l'insertion du résultat !"
            }
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du résultat !"
          })
    },
    returnJourney(journee) {
      return (parseInt(journee) === 1) ? (journee + 'ère journée') : (journee + 'ème journée')
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'matchs_non_joues'
    })
        .then((data) => {
          this.matchs = data.data
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'terrains'
    })
        .then((data) => {
          this.terrains = data.data
        })
        .catch((data) => {
          this.terrains = data
        })
    //
    this.axiosGetAllData({
      table: 'arbitres'
    })
        .then((data) => {
          this.arbitres = data.data
        })
        .catch((data) => {
          this.arbitres = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/components/Create.vue